import { render, staticRenderFns } from "./WatchDogProject.vue?vue&type=template&id=5161b958&scoped=true"
import script from "./WatchDogProject.vue?vue&type=script&setup=true&lang=js"
export * from "./WatchDogProject.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WatchDogProject.vue?vue&type=style&index=0&id=5161b958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161b958",
  null
  
)

export default component.exports